/**
 * Formes de l'écran « Mystify » du fond Écran de veille 95 : des polygones dont chaque sommet rebondit contre les bords.
 * Aucun dessin ici, seulement du calcul (donc testable) : le composant en fait des animations SVG qui bouclent sans minuteur.
 *
 * Un sommet va et vient entre deux bords en onde triangulaire (vitesse constante, demi-tour au bord). Pour que toute la boucle
 * se referme exactement, le nombre d'allers-retours de chaque coordonnée est pris dans REBONDS et son départ est un bord ou le
 * milieu : les demi-tours tombent alors toujours sur un échantillon (ECHANTILLONS est un multiple de 2 × chaque nombre).
 */

export const ECHANTILLONS = 24;
export const REBONDS = [1, 2, 3, 4, 6];

/** Générateur pseudo-aléatoire à graine (mulberry32). */
function aleatoire(graine) {
    let a = graine >>> 0;
    return () => {
        a = (a + 0x6D2B79F5) >>> 0;
        let t = a;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

/** Onde triangulaire de période 1 : 0 en u = 0, 1 en u = 0,5, retour à 0 en u = 1. */
export function triangle(u) {
    const f = u - Math.floor(u);
    return 1 - Math.abs(2 * f - 1);
}

/** Les sommets d'une forme (même graine, mêmes sommets) : pour chaque coordonnée, nombre d'allers-retours et départ (0 ou 0,5). */
export function sommets(graine, nombre = 4) {
    const r = aleatoire(graine * 7919 + 13);
    const rebonds = () => REBONDS[Math.floor(r() * REBONDS.length)];
    const depart = () => (r() < 0.5 ? 0 : 0.5);
    return Array.from({length: nombre}, () => ({nx: rebonds(), ny: rebonds(), px: depart(), py: depart()}));
}

/** Position d'un sommet à l'échantillon `i` (0 à ECHANTILLONS, le dernier égale le premier), dans [marge, taille - marge]. */
export function position(sommet, i, largeur, hauteur, marge) {
    const f = i / ECHANTILLONS;
    return {
        x: marge + triangle(sommet.nx * f + sommet.px) * (largeur - 2 * marge),
        y: marge + triangle(sommet.ny * f + sommet.py) * (hauteur - 2 * marge),
    };
}

/** Texte `points` d'un polygone SVG à l'échantillon `i`. */
export function points(forme, i, largeur, hauteur, marge) {
    return forme.map(s => {
        const p = position(s, i, largeur, hauteur, marge);
        return `${p.x.toFixed(1)},${p.y.toFixed(1)}`;
    }).join(" ");
}

/** Toutes les valeurs d'une animation SVG de `points` : ECHANTILLONS + 1 textes séparés par des points-virgules. */
export function valeursAnimation(forme, largeur, hauteur, marge) {
    return Array.from({length: ECHANTILLONS + 1}, (_, i) => points(forme, i, largeur, hauteur, marge)).join(";");
}
